module.exports = __webpack_public_path__ + "static/img/description-orbit-phasing.9eed408.png";